import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-6d.svg'

const data = {
  question:
    'Sharon is at a sleepover when a friend starts vaping and asks Sharon if she wants to try it. Most of Sharon’s friends do not vape and she doesn’t want to either, but it is hard to say ‘no’ to her friend, especially with other people around. Select all of the positive ways Sharon could refuse to vape.',
  inputType: 'checkbox',
  options: [
    {
      label: 'She could directly refuse by saying, “No, thank you.”',
    },
    {
      label:
        'She could tell her friend that vaping is dangerous and addictive.',
    },
    {
      label:
        'She could vape this time, and next time it will be easier to refuse.',
    },
    {
      label:
        'She could suggest that they talk with their volleyball coach before she tries it.',
    },
    {
      label:
        'She could say she wants to talk with her cousin in high school who vapes before she tries it.',
    },
  ],
}

const correctInput = {
  [data.question]: [
    data.options[0].label,
    data.options[1].label,
    data.options[3].label,
  ],
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'There are many good options when trying to find ways to say ‘no’ to vaping.',
  },
  error: {
    title: 'Not quite.',
    body:
      'There a many good options when trying to find ways to refuse vaping, like saying ‘no’ strongly or talking to a trusted adult. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 4',
  path: '/prepare/question-4',
  content: (
    <Fragment>
      <Intro title="Question 4" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question4.js